export const automatedSurveysRoutes = {
  list: "",
  create: "new",
  edit: ":id/edit",
  details: "active/:id",
} as const;
